import React, { useState } from 'react'
import styled from 'styled-components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: rgba(0, 0, 0, 0.8);

    > div {
        video {
            position: relative;
        }

        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        button {
            position: absolute;
            z-index: 2;
            top: -35px;
            right: -35px;
            display: inline-block;
            width: 35px;
            height: 35px;
            overflow: hidden;
            border: none;
            background: transparent;

            &:before {
                transform: rotate(45deg);
            }

            &:after {
                transform: rotate(-45deg);
            }

            &:before,
            &:after {
                content: '';
                position: absolute;
                height: 2px;
                width: 100%;
                top: 50%;
                left: 0;
                margin-top: -1px;
                background: #fff;
                border-radius: 5px;
                margin-top: -6px;
            }
        }
    }

    &.animate-enter {
        transition: opacity 300ms ease-in-out;
        opacity: 0;
        video {
            transition: transform 200ms ease-in-out;
            transform: translateY(100px);
        }
    }

    &.animate-enter-active {
        opacity: 1;
        video {
            transform: translateY(0px);
        }
    }

    &.animate-exit {
        transition: opacity 300ms ease-in-out;
        opacity: 1;
    }

    &.animate-exit-active {
        opacity: 0;
    }

    video {
        max-width: 100%;
        width: 740px;
        border-radius: 12px;
    }
`

export default ({ url, show, onClose }) => {
    return (
        <TransitionGroup component={null}>
            {show && (
                <CSSTransition key={1} timeout={300} classNames="animate">
                    <Wrapper onClick={onClose}>
                        <div>
                            <video onEnded={() => onClose()} autoPlay>
                                <source type="video/mp4" src={url}></source>
                            </video>
                        </div>
                    </Wrapper>
                </CSSTransition>
            )}
        </TransitionGroup>
    )
}
